export const imageBasePath = window.location.protocol + "//" + window.location.host + "/assets/";